export default __webpack_public_path__ + "static/media/github.850c98d0.svg";